const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'; // Default FastAPI port

// 增强的fetch函数，用于处理API调用
const enhancedFetch = (url, options = {}, logoutHandler = null) => {
  // 默认选项
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  // 合并选项
  const mergedOptions = {
    ...defaultOptions,
    ...options,
  };

  // 执行fetch请求
  return fetch(url, mergedOptions)
    .then(response => {
      // 检查是否是401未授权错误
      if (response.status === 401) {
        // 如果提供了登出处理函数，则调用它
        if (logoutHandler) {
          logoutHandler();
        }
      }
      return response;
    })
    .catch(error => {
      throw error;
    });
};

export { API_BASE_URL, enhancedFetch };